import { read as xlsxRead, utils as xlsxUtils } from 'xlsx'

// Parses a .xlsx/.xls File into the same { headers, rows } shape parseCsv() returns —
// rows stays array-of-arrays (not keyed objects) so ContactImport's index-based column
// mapping works identically regardless of which file type was uploaded.
export async function parseExcel(file) {
  const buffer = await file.arrayBuffer()
  const workbook = xlsxRead(buffer, { type: 'array' })
  const sheetName = workbook.SheetNames[0]
  if (!sheetName) return { headers: [], rows: [] }

  const worksheet = workbook.Sheets[sheetName]
  const records = xlsxUtils.sheet_to_json(worksheet, { header: 1, defval: '', blankrows: false })

  const [rawHeaders, ...rawRows] = records
  const headers = (rawHeaders || []).map((h) => String(h).trim()).filter(Boolean)
  if (headers.length === 0) return { headers: [], rows: [] }

  const rows = rawRows
    .map((record) => headers.map((_, idx) => String(record[idx] ?? '').trim()))
    .filter((row) => row.some((v) => v))

  return { headers, rows }
}

// Minimal RFC4180-ish CSV parser: handles quoted fields, embedded commas/newlines, "" escaping.
export function parseCsv(text) {
  const rows = []
  let row = []
  let field = ''
  let inQuotes = false

  const pushField = () => { row.push(field); field = '' }
  const pushRow = () => { pushField(); rows.push(row); row = [] }

  for (let i = 0; i < text.length; i++) {
    const char = text[i]
    const next = text[i + 1]

    if (inQuotes) {
      if (char === '"' && next === '"') { field += '"'; i++ }
      else if (char === '"') { inQuotes = false }
      else { field += char }
      continue
    }

    if (char === '"') { inQuotes = true }
    else if (char === ',') { pushField() }
    else if (char === '\r') { /* skip, \n handles the row break */ }
    else if (char === '\n') { pushRow() }
    else { field += char }
  }

  // Trailing field/row (file without a final newline)
  if (field.length > 0 || row.length > 0) pushRow()

  const nonEmptyRows = rows.filter((r) => !(r.length === 1 && r[0] === ''))
  if (nonEmptyRows.length === 0) return { headers: [], rows: [] }

  const [headers, ...dataRows] = nonEmptyRows
  return { headers: headers.map((h) => h.trim()), rows: dataRows }
}
